export default __webpack_public_path__ + "static/media/gallery_02.15fd66c3.jpg";